import React from 'react'
import {
    createHandleNew,
    defaultValues,
    initialErrors,
    validateHandle,
} from './defaultValues'
import { Textinput } from '@yandex/ui/Textinput/desktop/bundle'
import { Tumbler } from '../../../components/Tumbler/Tumbler'
import { Button, cnButton } from '../../../components/Button'
import { cn } from '@bem-react/classname'
import { IHandleData } from '../../../../../common-code/interfaces/materials/IHandleData'
import HandleModels from './HandleModels/HandleModels'
import InputFile from '../../../components/InputFile/InputFile'
import Trash from '../../../components/icons/Trash'
import './FormHandle.css'
import { useSelector } from 'react-redux'
import { AppState } from '../../../../redux/AppStore'
import {
    BUTTON_LEFT_ICON_PLUS_2,
    BUTTON_MODE_LIGHT_GREEN,
} from '../../../constants'
import {IAlign} from '../../../../../common-code/interfaces/geometry/IAlign';
import {ALIGN_CENTER, HANDLE_TYPE_HORIZONTAL} from '../../../../../common-code/constants';
import {IDetailPosition} from '../../../../../common-code/interfaces/geometry/IDetailPosition';
import {THandleType} from '../../../../../common-code/types/handle/THandleType';
import {Select} from '../../../components/Select/Select';
import {cnFormFacade} from '../FormFacade/FormFacade';
import {editOption} from '../utils/editOption';
import {alignValues} from '../FormFacade/Handle/Handle';
import {TAlign} from '../../../../../common-code/types/TAlign';

export const cnFormHandle = cn('FormHandle')

export interface INewHandleData extends IHandleData {
    imageNew?: File | null
}
export interface IFormHandleProps {
    saveHandlesCollection: (itemHandle: INewHandleData) => Promise<void>
    editHandlesCollection: (itemHandle: INewHandleData) => Promise<void>
}

function FormHandle({
    saveHandlesCollection,
    editHandlesCollection,
}: IFormHandleProps) {
    const initialValue = useSelector(
        (state: AppState) => state.wizard.editMaterial.itemHandle
    )
    const [newHandle, setNewHandle] = React.useState<INewHandleData>(
        defaultValues(initialValue || null)
    )

    const formRef = React.useRef<HTMLFormElement>(null)

    const scrollToForm = () =>
        formRef?.current?.scrollIntoView({ block: 'start', behavior: 'smooth' })

    const {
        id,
        //обязательные
        title,
        models,
        //необязательные
        image,
        isDefault,
        disable,
        imageNew,
        vendorCode,
        align,
        // aligns,
        margin,
        // // margins,
        // location,
        // // locations,
        // horizontalMove,
        // // horizontalMoves,
    } = newHandle

    const [errors, setErrors] = React.useState(initialErrors)

    const onInputChange = (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
    ) => {
        setNewHandle({ ...newHandle, [e.target.name]: e.target.value })
    }

    const onChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewHandle({ ...newHandle, [e.target.name]: e.target.checked })
    }

    const onFocus = () => {
        setNewHandle({ ...newHandle })
        setErrors(initialErrors)
    }
    const handleSubmit = () => {
        const error = validateHandle(newHandle)
        if (error) {
            scrollToForm()
            setErrors({ ...errors, title: error })
            return
        }
        const handle = createHandleNew(newHandle)
        console.log('handle', handle)
        return handle
    }

    const addFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewHandle({
            ...newHandle,
            imageNew: Array.from(e.target.files as FileList)[0],
            image: '',
        })
        setErrors(initialErrors)
    }

    const filterFunction = () => {
        setNewHandle({ ...newHandle, imageNew: null, image: '' })
        setErrors(initialErrors)
    }
    // функция удаления выбранного фото
    const deleteImage = () => {
        setNewHandle({ ...newHandle, image: '' })
    }
    const saveHandle = () => {
        const handle = handleSubmit()
        if (handle) {
            saveHandlesCollection(handle)
        }
    }
    const editHandle = () => {
        const handle = handleSubmit()
        if (handle) {
            editHandlesCollection(handle)
        }
    }

    const edit = !!initialValue

    const toggleField = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
        let value: any | undefined = undefined;
        switch (fieldName) {
            case 'align':
                if (e.target.checked) {
                    value = {x: ALIGN_CENTER, y: ALIGN_CENTER} as IAlign;
                }
                break;
            case 'margin':
                if (e.target.checked) {
                    value = {x: 0, y: 0, z: 0} as IDetailPosition;
                }
                break;
            case 'location':
                if (e.target.checked) {
                    value = HANDLE_TYPE_HORIZONTAL as THandleType;
                }
                break;
            case 'horizontalMove':
                if (e.target.checked) {
                    value = e.target.checked;
                }
                break;
        }
        setNewHandle({...newHandle, [e.target.name]: value})
    }

    const onObjectChange = (
        groupName: string,
        fieldName: string,
        value: any
    ) => {
        let changedHandle: INewHandleData = {...newHandle};
        switch (groupName) {
            case 'align':
                let changedAlign: IAlign = changedHandle.align || {};
                switch (fieldName) {
                    case 'x':
                        changedAlign.x = value as TAlign;
                        break;
                    case 'y':
                        changedAlign.y = value as TAlign;
                        break;
                }
                changedHandle.align = changedAlign;
                break;
            case 'margin':
                let changedMargin: IDetailPosition = changedHandle.margin || {};
                switch (fieldName) {
                    case 'x':
                        changedMargin.x = value;
                        break;
                    case 'y':
                        changedMargin.y = value;
                        break;
                    case 'z':
                        changedMargin.z = value;
                        break;
                }
                changedHandle.margin = changedMargin;
                break;
        }
        setNewHandle(changedHandle);
    };

    return (
        <div className={cnFormHandle('')}>
            <div className={cnFormHandle('Container')}>
                <h3 className={cnFormHandle('Header')}>
                    {edit ? 'Редактирование ручки' : 'Добавление ручки'}
                </h3>

                <form className={cnFormHandle('Content')} ref={formRef}>
                    {edit && (
                        <p className={cnFormHandle('Id')}>
                            ID ручки: &nbsp; {id}
                        </p>
                    )}
                    <label htmlFor="title">Название ручки *</label>

                    {models.length > 0 ? (
                        <div>
                            <p>{title}</p>
                            <p className={cnFormHandle('Explanations')}>
                                ( изменить название ручки после добавления
                                моделей невозможно )
                            </p>
                        </div>
                    ) : (
                        <Textinput
                            className={cnFormHandle('Textinput')}
                            value={title}
                            onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                            ) => onInputChange(e)}
                            name="title"
                            type="text"
                            maxLength={50}
                            onFocus={onFocus}
                        />
                    )}
                    {errors.title && (
                        <p className="text-danger">{errors.title}</p>
                    )}

                    <HandleModels
                        newHandle={newHandle}
                        setNewHandle={setNewHandle}
                        setErrors={setErrors}
                    />
                    <h5>Изображение ручек</h5>

                    {image && !imageNew && (
                        <div className={cnFormHandle('Children')}>
                            <span>{image.split('/').at(-1) as string}</span>
                            <img width={50} height={50} src={image} alt="..." />
                            <div className={cnFormHandle('Box-Btn')}>
                                <Trash handleDeleteValue={deleteImage} />
                            </div>
                        </div>
                    )}
                    <InputFile
                        file={imageNew as File | null}
                        addFiles={addFiles}
                        filterFunction={filterFunction}
                    />

                    <Tumbler
                        className={cnFormHandle('Tumbler')}
                        checked={isDefault as boolean}
                        callBack={(e: React.ChangeEvent<HTMLInputElement>) =>
                            onChecked(e)
                        }
                        label="Определить как ручка по умолчанию"
                        name="isDefault"
                    />

                    <Tumbler
                        className={cnFormHandle('Tumbler')}
                        checked={disable as boolean}
                        callBack={(e: React.ChangeEvent<HTMLInputElement>) =>
                            onChecked(e)
                        }
                        label="Деактивировать ручку"
                        name="disable"
                    />

                    <Tumbler
                        className={cnFormHandle('Tumbler')}
                        checked={align !== undefined}
                        callBack={(e: React.ChangeEvent<HTMLInputElement>) =>
                            toggleField(e, 'align')
                        }
                        label="Позиционирование по-умолчанию"
                        name="align"
                    />
                    {align !== undefined && (
                        <div className={cnFormHandle('ChildGroup')}>
                            <div className={cnFormHandle('ChildGroupItem')}>
                                <label htmlFor="handleAlignX">По горизонтали</label>
                                <Select
                                    className={cnFormFacade("Select")}
                                    placeholder={"Выберите значение"}
                                    showPlaceholder={false}
                                    options={editOption(alignValues)}
                                    value={align.x || ALIGN_CENTER}
                                    callBack={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                        onObjectChange('align', 'x', e.target.value)
                                    }}
                                />
                            </div>
                            <div className={cnFormHandle('Child')}>
                                <label htmlFor="handleAlignY">По вертикали</label>
                                <Select
                                    className={cnFormFacade("Select")}
                                    placeholder={"Выберите значение"}
                                    showPlaceholder={false}
                                    options={editOption(alignValues)}
                                    value={align.y || ALIGN_CENTER}
                                    callBack={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                        onObjectChange('align', 'y', e.target.value)
                                    }}
                                />
                            </div>
                        </div
                    >)}
                    <Tumbler
                        className={cnFormHandle('Tumbler')}
                        checked={margin !== undefined}
                        callBack={(e: React.ChangeEvent<HTMLInputElement>) =>
                            toggleField(e, 'margin')
                        }
                        label="Отступ по-умолчанию"
                        name="margin"
                    />
                    {margin !== undefined && (
                        <div className={cnFormHandle('ChildGroup')}>
                            <div className={cnFormHandle('ChildGroupItem')}>
                                <label htmlFor="handleMarginX">По горизонтали</label>
                                <Textinput
                                    className={cnFormFacade("Textinput")}
                                    value={margin.x || 0}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                        onObjectChange('margin', 'x', e.target.value)
                                    }
                                    name="handleMarginX"
                                    type="number"
                                />
                            </div>
                            <div className={cnFormHandle('ChildGroupItem')}>
                                <label htmlFor="handleMarginY">По высоте</label>
                                <Textinput
                                    className={cnFormFacade("Textinput")}
                                    value={margin.y || 0}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                        onObjectChange('margin', 'y', e.target.value)
                                    }
                                    name="handleMarginY"
                                    type="number"
                                />
                            </div>
                            <div className={cnFormHandle('ChildGroupItem')}>
                                <label htmlFor="handleMarginZ">По глубине</label>
                                <Textinput
                                    className={cnFormFacade("Textinput")}
                                    value={margin.z || 0}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                        onObjectChange('margin', 'z', e.target.value)
                                    }
                                    name="handleMarginZ"
                                    type="number"
                                />
                            </div>
                        </div
                        >)}

                    <h5>Код товара ручки или ИД Битрикс торгового предложения (если заполнен, то будет добавляться этот код товара в спецификацию)</h5>
                    <Textinput
                        className={cnFormHandle('Textinput')}
                        value={vendorCode}
                        onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                        ) => onInputChange(e)}
                        name="vendorCode"
                        type="text"
                        maxLength={50}
                        onFocus={onFocus}
                    />

                    <div className={cnFormHandle('Footer')}>
                        <div className={cnFormHandle('Footer-Button-Add')}>
                            <Button
                                className={cnFormHandle(cnButton())}
                                type={'button'}
                                text={'Добавить новую ручку в коллекцию'}
                                leftIcon={BUTTON_LEFT_ICON_PLUS_2}
                                mods={BUTTON_MODE_LIGHT_GREEN}
                                callBack={saveHandle}
                            />
                            {edit && (
                                <Button
                                    className={cnFormHandle(cnButton())}
                                    type={'button'}
                                    text={
                                        'Заменить редактируемую ручку в коллекции'
                                    }
                                    mods={BUTTON_MODE_LIGHT_GREEN}
                                    callBack={editHandle}
                                />
                            )}
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default FormHandle
